import {Controller} from "stimulus"
import {throttle} from "./../utils/utils.js"

export default class extends Controller {

    static targets = [
        "menuItems"
    ]

    initialize() {

        this.check()

        window.addEventListener("scroll", e => this.check())
        window.addEventListener("resize", throttle(e => this.check(), 100))

    }

    check() {

        const scrollY = window.scrollY
        const windowH = window.innerHeight
        const windowPosition = scrollY

        /*if ( scrollY <= 400 ) {
            this.removeActiveToAll()
            return;
        }*/


        this.menuItemsTargets.forEach($item => {

            const $a = $item.querySelector("a")
            const href = $a.getAttribute("href")
            const $section = document.querySelector(href)
            let offset = this.data.get("offset")
            console.log("offset", offset)
            offset = offset ? parseInt(offset) : 0
            // When the section is at /3 of the screen
            //const positionRef = getOffsetTop($section) - ((windowH / 3) * 1) if one/third is on screen
            const positionRef = getOffsetTop($section) - offset

            if (windowPosition > positionRef) {
                this.removeActiveToAll()
                $item.classList.add("is-active")
            }

        })

    }

    removeActiveToAll() {
        const $items = this.menuItemsTargets.filter($item => $item.classList.contains("is-active"))
        const $active = $items ? $items[0] : false
        $active ? $active.classList.remove("is-active") : false
    }

}